import React from "react";
import Controls from "src/components/form/controls/Controls";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import ShowCacheFLFRogoDevSubType from "../ShowCache/ShowCacheFLFRogoDevSubType";
import { CACHE_ROGO_DEV_SUB_TYPE } from "src/constants/actionCache";
import FLFRogoDevSubTypePopup from "../Popup/FLFRogoDevSubTypePopup";

const FLFRogoDevSubTypeControlPanel = ({
  children,
  isSorted,
  handleSort,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache RogoDevSubType"
          isShowButton={isShowCache(
            currentActionCache,
            CACHE_ROGO_DEV_SUB_TYPE
          )}
        >
          <ShowCacheFLFRogoDevSubType
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}
        <FLFRogoDevSubTypePopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFRogoDevSubTypeControlPanel;
